<template>
    <div class="qksm page" v-if="$store.state.divData.zone=='laiwu' && $parent.year==2021">
        <h4>（四）预算绩效管理情况</h4>
        <p class="hide_pdf red">
            （2021年相关财政拨款安排的项目是否全部涉密<reason type="select" classname="qksm select " name="预算资金涉密" v-model:value="qksm['预算资金涉密']" optionarr="请选择,是,否"></reason>）<br />
        </p>
        <p v-if="qksm['预算资金涉密']=='是'">
            {{$parent.year}}年{{$store.state.divData.divname}}财政拨款安排的项目，按规定不涉及绩效目标设置公开事项。
        </p>
        <template v-else>
            <p v-if="isPdf && num(qksm['绩效财政拨款']) == 0">
                2021年{{$store.state.divData.divname}}无财政拨款业务类和投资发展类项目，不涉及绩效目标设置。
            </p>
            <template v-else>
                <p>
                    {{$store.state.divData.divname}}2021年项目支出实现绩效目标管理全覆盖，涉及财政拨款
                    <reason type="money" classname="reason money" name="绩效财政拨款" v-model:value="qksm['绩效财政拨款']"></reason>万元。其中本{{typeText}}所主管专项资金的绩效目标表如下：
                </p>
                <p class="hide_pdf upload" @click="uploadJx('bmzxzj')" v-if="num(qksm['绩效财政拨款'])>0">*【->点此前往】上传部门主管专项资金绩效目标表</p>
            </template>
        </template>
    </div>
    <template v-else>
        <div class="qksm page">
            <h4>（四）预算绩效管理情况</h4>
            <p class="hide_pdf red" v-if="!isBinzhou">
                （是否只有人员类项目、运转类公用经费项目<reason type="select" classname="qksm select " name="公用经费项目" v-model:value="qksm['公用经费项目']" optionarr="请选择,是,否"></reason>）<br />
            </p>
            <div class="nogap">
                <p v-if="qksm['公用经费项目']=='是' || (isPdf && num(qksm['绩效项目支出'])==0)">
                    {{$store.state.divData.divname}}{{$parent.year}}年预算资金安排的相关项目，按规定不涉及绩效目标设置公开事项。
                </p>
                <template v-else>
                    <p class="hide_pdf red">
                        （{{$parent.year}}年预算资金安排的相关项目是否全部涉密<reason type="select" classname="qksm select " name="预算资金涉密" v-model:value="qksm['预算资金涉密']" optionarr="请选择,是,否"></reason>）<br />
                    </p>
                    <p v-if="qksm['预算资金涉密']=='是'">
                        {{$store.state.divData.divname}}{{$parent.year}}年预算资金安排的相关项目，按规定不涉及绩效目标设置公开事项。
                    </p>
                    <p v-else>
                        <span class="hide_pdf red">
                            如相关预算资金安排的项目部分涉密，按规定剔除相关项目支出个数和预算资金金额。如无剔除，下面文字描述中的实施绩效目标管理的项目个数和金额要跟单位公开表13一致。<br />
                        </span>
                        {{$store.state.divData.divname}}{{$parent.year}}年项目支出全面实施绩效目标管理，涉及预算项目支出
                        <reason type="integer" classname="reason integer must" name="绩效项目支出" v-model:value="qksm['绩效项目支出']"></reason>个，预算资金
                        <reason type="money" classname="reason money" name="绩效预算资金" v-model:value="qksm['绩效预算资金']"></reason>万元，其中财政拨款
                        <reason type="money" classname="reason money" name="绩效财政拨款" v-model:value="qksm['绩效财政拨款']"></reason>万元。
                        <template v-if="num(qksm['绩效项目支出'])>0">
                            <template v-if="(isBinzhou || (!isBinzhou && $store.state.divData.type==0)) && isPdf && num(qksm['重点拟项目个'])==0 && num(qksm['重点预算资金'])==0 && num(qksm['重点财政拨款'])==0">
                            </template>
                            <template v-else>
                                拟对
                                <template v-if="qksm['重点拟项目个'] != 0 ">
                                    <reason type="textarea" classname="reason" name="重点拟项目" v-model:value="qksm['重点拟项目']"></reason>
                                    等
                                </template>
                                <reason type="integer" classname="reason integer must" name="重点拟项目个" v-model:value="qksm['重点拟项目个']"></reason>个项目开展{{isBinzhou && $store.state.divData.type==0 ? "" : "部门"}}重点绩效评价，涉及预算资金
                                <reason type="money" classname="reason money" name="重点预算资金" v-model:value="qksm['重点预算资金']"></reason>万元，其中财政拨款
                                <reason type="money" classname="reason money" name="重点财政拨款" v-model:value="qksm['重点财政拨款']"></reason>万元。
                                <span class="hide_pdf red" v-if="$store.state.divData.type==0">如果不拟开展项目重点绩效评价，填写“0”即可。</span>
                            </template>
                            <template v-if="(qksm['绩效项目支出'] != 0 && !isPdf) || (isPdf && qksm['优化项目']!=0)">
                                根据以前年度绩效评价结果，优化
                                <reason type="textarea" classname="reason" name="优化项目" v-model:value="qksm['优化项目']"></reason>等项目支出{{$parent.year}}年预算安排，进一步改进管理、完善政策。
                                <span class="hide_pdf red" v-if="!isBinzhou">如果没有根据以前年度绩效评价结果进行优化项目支出{{$parent.year}}年预算安排的，填写“0”即可。</span>
                            </template>
                        </template>
                    </p>
                    <p class="hide_pdf red" v-if="(zone!='laiwu' && !isBinzhou) || ($store.state.divData.type!=0 && isBinzhou)">
                        是否涉及部门主管专项资金绩效目标公开（专项资金以主管部门为主体公开，应与报人大参阅专项资金绩效目标保持一致，需逐项列示）：
                        <reason type="select" classname="reason" name="部门专项资金" v-model:value="qksm['部门专项资金']" optionarr="请选择,是,否"></reason>
                    </p>
                </template>

            </div>
            <p></p>
        </div>
        <div class="qksm page" v-if="(isPdf && qksm['剔除涉密科目']=='是') || !isPdf">
            <div class="hide_pdf">
                <template v-if="qksm['部门专项资金']=='是' && qksm['公用经费项目']!='是'">
                    <h4>（五）部门主管专项资金的绩效目标表</h4>
                    <p class="upload" @click="uploadJx('bmzxzj')">*【->点此前往】上传部门主管专项资金绩效目标表</p>
                </template>
                <template v-if="num(qksm['绩效项目支出'])>0 && qksm['预算资金涉密'] != '是' && qksm['公用经费项目']!='是'">
                    <h4>
                        （{{qksm['部门专项资金']=='是' ? '六' : '五'}}）{{typeText}}预算重点项目的绩效目标表
                    </h4>
                    <p v-if="zone != 'dezhou' && zone != 'yuncheng' && zone != 'zhanhua'" class="red">
                        {{$store.state.divData.type==0 && isBinzhou ? "": "每个部门原则上公开2-3个项目。"}}{{!isBinzhou ? "其中，已报送人大参阅项目全部纳入公开范围；" :""}}部门所属单位应至少公开1个项目。其中，主管部门已公开的重点项目须纳入单位公开范围，内容应当相互衔接。
                    </p>
                    <p v-if="zone == 'zhanhua'" class="red">
                        {{$store.state.divData.type==0 ? "部门所属单位应公开所有项目的绩效目标表。": "每个部门原则上需要公开所有项目的绩效目标表。"}}其中，主管部门已公开的重点项目须纳入单位公开范围，内容应当相互衔接。
                    </p>
                    <p v-if="zone == 'yuncheng'" class="red">
                        {{typeText}}预算项目绩效目标表均需公开（涉密除外），其中部门选择2-3个重点项目、部门所属单位至少选择1个重点项目公开重点项目绩效目标表。主管部门已公开的重点项目纳入单位公开范围，内容应当相互衔接。
                    </p>
                    <p class="upload" @click="uploadJx('jxmbb')">*【->点此前往】上传{{typeText}}预算重点项目的绩效目标表</p>
                </template>
                <p class="red">
                    {{isBinzhou ? typeText+"预算中是否有对涉密功能科目以及项目支出、项目支出绩效目标剔除？" : typeText+"预算中是否有对涉密功能科目剔除？"}}
                    <reason type="select" classname="reason" name="剔除涉密科目" v-model:value="qksm['剔除涉密科目']" optionarr="请选择,是,否"></reason>
                </p>
            </div>
            <div class="nogap">
                <template v-if="qksm['剔除涉密科目']=='是'">
                    <h4>（{{qksm['部门专项资金']=='是' && num(qksm['绩效项目支出'])>0 && qksm['公用经费项目']!='是' ? '七' : ((qksm['部门专项资金']=='是' || num(qksm['绩效项目支出'])>0) && qksm['公用经费项目']!='是' ? '六' : '五')}}）涉密事项说明</h4>
                    <p>
                        {{$store.state.divData.divname}}的部门预算中
                        <reason type="textarea" classname="reason" name="涉密事项说明" v-model:value="qksm['涉密事项说明']"></reason>科目下有关款级、项级科目支出以及项目支出绩效目标，已经国家保密部门确认为涉及国家秘密的信息，根据国家保密法律法规和有关保密事项范围的规定，在预算公开中予以剥离。
                    </p>
                </template>
            </div>
            <p></p>
        </div>
    </template>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm12",
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm
            var zone = this.$store.state.divData.zone
            let isBinzhou = zone.indexOf('binzhou') > -1 || zone == 'bincheng' || zone == 'zhanhua' ? true : false
            if (!qksm['公用经费项目'] || isBinzhou) {
                qksm['公用经费项目'] = '否'
            }
            if (zone == 'laiwu' && this.$store.state.openYear == 2021) {
                qksm['预算资金涉密'] = qksm['预算资金涉密'] == '是' ? '是' : '否'
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                typeText: this.$store.state.divData.type == 0 ? "单位" : "部门",
                attachments: this.$store.state.divData.attachments,
                zone: zone,
                isBinzhou: isBinzhou
            }
        },
        created() {
            this.inspect()
        },
        updated: function () {
            this.attachments = this.$store.state.divData.attachments
            this.inspect()
        },
        watch: {
            $route() {
                this.attachments = this.$store.state.divData.attachments
                this.inspect()
            },
        },
        methods: {
            uploadJx(name) {
                this.$router.push({ path: '/div/uploadPerform', query: { divid: this.$route.query.divid, tag: name }, });
            },
            inspect() {
                if (this.$store.state.divData.zone == 'laiwu' && this.$parent.year == 2021) {
                    if (this.qksm['预算资金涉密'] != '是'&& this.num(this.qksm['绩效财政拨款'])>0 && this.attachments.filter(e => e.claims.tag == 'bmzxzj').length == 0) {
                        this.addOrSet("jx1", "请上传部门主管专项资金的绩效目标表。");
                    } else if ((this.num(this.qksm['绩效财政拨款']) == 0 || this.qksm['预算资金涉密'] == '是') && this.attachments.filter(e => e.claims.tag == 'bmzxzj').length > 0) {
                        this.addOrSet("jx1", "请前往预算绩效-附件管理中删除部门主管专项资金的绩效目标表");
                    } else {
                        this.remove("jx1")
                    }
                } else {
                    if (this.qksm['公用经费项目'] != '是' && this.qksm['预算资金涉密'] != '是' && this.qksm['绩效项目支出'] > 0 && this.qksm['绩效预算资金'] <= 0) {
                        this.addOrSet("jx3", "请检查《（四）预算绩效管理情况》，如涉及预算项目个数大于0，则预算资金必须大于0。");
                    } else if (this.qksm['公用经费项目'] != '是' && this.qksm['预算资金涉密'] != '是' && this.qksm['绩效项目支出'] == 0 && this.qksm['绩效预算资金'] != 0) {
                        this.addOrSet("jx3", "请检查《（四）预算绩效管理情况》，如涉及预算项目个数等于0，则预算资金必须等于0。");
                    } else {
                        this.remove("jx3")
                    }

                    if (this.qksm['公用经费项目'] != '是' && this.qksm['预算资金涉密'] != '是' && this.qksm['重点拟项目个'] > 0 && this.qksm['重点预算资金'] <= 0) {
                        this.addOrSet("jx4", "请检查《（四）预算绩效管理情况》，如有开展部门重点绩效评价项目，则涉及预算资金必须大于0。");
                    } else if (this.qksm['公用经费项目'] != '是' && this.qksm['预算资金涉密'] != '是' && this.qksm['重点拟项目个'] == 0 && this.qksm['重点预算资金'] != 0) {
                        this.addOrSet("jx4", "请检查《（四）预算绩效管理情况》，如没有开展部门重点绩效评价项目，则涉及预算资金必须等于0。");
                    } else {
                        this.remove("jx4")
                    }
                    if (this.qksm['公用经费项目'] != '是' && this.qksm['预算资金涉密'] != '是' && this.qksm['绩效项目支出'] == 0 && !this.isBinzhou) {
                        this.addOrSet("jx5", "请检查《（四）预算绩效管理情况》，涉及预算项目个数必须大于0。");
                    } else {
                        this.remove("jx5")
                    }

                    if (this.qksm['公用经费项目'] != '是' && this.qksm['部门专项资金'] == '是' && this.attachments.filter(e => e.claims.tag == 'bmzxzj').length == 0) {
                        this.addOrSet("jx1", "请上传部门主管专项资金的绩效目标表。");
                    } else if ((this.qksm['公用经费项目'] == '是' || this.qksm['部门专项资金'] != '是') && this.attachments.filter(e => e.claims.tag == 'bmzxzj').length > 0) {
                        this.addOrSet("jx1", "请前往预算绩效-附件管理中删除部门主管专项资金的绩效目标表");
                    } else {
                        this.remove("jx1")
                    }
                    if (this.qksm['公用经费项目'] != '是' && this.num(this.qksm['绩效项目支出']) > 0 && this.qksm['预算资金涉密'] != '是' && this.attachments.filter(e => e.claims.tag == 'jxmbb').length == 0) {
                        this.addOrSet("jx2", "请上传部门预算重点项目的绩效目标表。");
                    } else if ((this.num(this.qksm['绩效项目支出']) == 0 || this.qksm['预算资金涉密'] == '是' || this.qksm['公用经费项目'] == '是') && this.attachments.filter(e => e.claims.tag == 'jxmbb').length > 0) {
                        this.addOrSet("jx2", "请前往预算绩效-附件管理中删除部门预算重点项目的绩效目标表");
                    } else {
                        this.remove("jx2")
                    }
                }
                
            }
        }
    };
</script>
<style scoped>
    .upload {
        color: #9ECADF;
        font-weight: 600;
    }
</style>